import { browserHistory, hashHistory } from 'react-router';

export const getHistoryType = () => {
  const ie9HistoryInfo = {
    historyType: hashHistory,
    isIE9: true,
  };
  const nonIE9HistoryInfo = {
    historyType: browserHistory,
    isIE9: false,
  };

  try {
    // Check for IE9 or older
    if (document && document.all && (window && !window.atob)) {
      return ie9HistoryInfo;
    }

    return nonIE9HistoryInfo;
  } catch (error) {
    console.error(error); //eslint-disable-line
    return ie9HistoryInfo;
  }
}

export default {
  getHistoryType,
};
